export enum AuthProvider {
  Github = "github",
  Bitbucket = "bitbucket",
  Gitlab = "gitlab",
  Google = "google",
}
